var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "25px",
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6E1B8867-601F-43A2-8414-5B8312D08241") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Individual-Entry/Feedback",
    transform: "translate(-705.000000, -2249.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Judging-Tools",
    transform: "translate(0.000000, 2210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Draft-Entry",
    transform: "translate(705.285935, 39.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#B7844D",
    strokeWidth: 1.35,
    x: 0.675,
    y: 2.61526574,
    width: 18.1595027,
    height: 21.7097343
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#B7844D",
    points: "22.2679729 0 12.406616 9.06503775 15.1386432 11.5766271 25 2.51094884"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#B7844D",
    points: "11.0662435 12.8119884 14.4804065 12.1816889 11.7483793 9.67009956"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.87737567,
    y1: 6.42410296,
    x2: 14.632127,
    y2: 6.42410296,
    id: "Line-5",
    stroke: "#B7844D",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    strokeDasharray: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.87737567,
    y1: 7.70519931,
    x2: 14.632127,
    y2: 7.70519931,
    id: "Line-5",
    stroke: "#B7844D",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    strokeDasharray: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.87737567,
    y1: 8.98629566,
    x2: 14.632127,
    y2: 8.98629566,
    id: "Line-5",
    stroke: "#B7844D",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    strokeDasharray: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.87737567,
    y1: 10.267392,
    x2: 11.8450552,
    y2: 10.267392,
    id: "Line-5",
    stroke: "#B7844D",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    strokeDasharray: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.87737567,
    y1: 12.8295847,
    x2: 9.05798339,
    y2: 12.8295847,
    id: "Line-5",
    stroke: "#B7844D",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    strokeDasharray: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.87737567,
    y1: 11.5484884,
    x2: 11.8450552,
    y2: 11.5484884,
    id: "Line-5",
    stroke: "#B7844D",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    strokeDasharray: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/Notes.599f815f9ad144bdb426044e5e723d8f.svg";
export { ForwardRef as ReactComponent };